var u = Object.defineProperty;
var m = (n, e, t) => e in n ? u(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var c = (n, e, t) => m(n, typeof e != "symbol" ? e + "" : e, t);
import l from "axios";
var v = /* @__PURE__ */ ((n) => (n[n.RefreshTokenFailed = 0] = "RefreshTokenFailed", n[n.GetTokenFailed = 1] = "GetTokenFailed", n[n.GetTokenEmpty = 2] = "GetTokenEmpty", n))(v || {});
class C {
  constructor() {
    c(this, "envConfig");
    c(this, "configured");
    c(this, "prodDomain");
    c(this, "appConfig");
    this.envConfig = this.getStandardProdConfig(), this.configured = !1, this.prodDomain = "", this.appConfig = this.getStandardAppConfig();
  }
  /**
   *
   * @returns EnvConfiguration the standard for prod
   */
  getStandardProdConfig() {
    return {
      name: "prod",
      gtmId: "",
      secureAccorComApi: "https://secure.accor.com",
      apiAccorComApi: "https://api.accor.com",
      apiAccorSecureComApi: "https://s-api.accor.com/secure",
      apiWcgwAwsAccorComApi: "https://api.wcgw.aws.accor.com",
      apiKey: "",
      allAccorComOrigin: "https://all.accor.com",
      oneTrustDataDomain: "87c4fef0-8732-44e4-bee3-f4faa4ce5a9d",
      isOneTrustEnabled: !1,
      pingApiUrl: "https://login.accor.com",
      xOriginHeaderValue: "",
      isBeaconMCPScriptEnabled: !1,
      apiBff: "https://api.accor.com/bff/v1/graphql",
      splunkRUM: void 0,
      splunkSessionRecorder: void 0
    };
  }
  getStandardAppConfig() {
    return {
      getLocale() {
        return console.warn("envManager - getLocale is not configured"), "en";
      },
      getAppVersion() {
        return console.warn("envManager - getAppVersion is not configured"), "";
      }
    };
  }
  getHtmlEnv() {
    return document.documentElement.getAttribute("env");
  }
  /**
   * Check if the SPA is in production or not. Check is based first on the attribute env in the <html> node, then on the domain.
   * @returns boolean whether the current env is the production environment
   */
  isProd() {
    return this.getHtmlEnv() ? this.getHtmlEnv() === "production" : this.prodDomain === window.location.host;
  }
  /**
   * Get the env name
   * @returns string the env name
   */
  getEnvName() {
    return this.envConfig.name;
  }
  /**
   * Configure the environment for the app
   * If on prod domain, then the manager will use the prodConfig param,
   * If not on prod domain, then it will fallback to dowloading the configuration
   * Both of these behaviors can be superseeded by the override function
   * @param prodDomain string
   * @param prodConfig Object
   * @param appConfig Object
   * @param confPath string=config.json
   * @param override Function Returns null if there is no override or EnvConfiguration. This can be wrapped in a promise
   * @returns Promise
   */
  async configure(e, t, i, a = "config.json", o) {
    this.configured && console.warn(
      "envManager - Environment configuration is already configured. Be careful when reconfiguring it."
    ), this.prodDomain = e, Object.assign(this.appConfig, i), Object.assign(this.envConfig, t);
    let r;
    if (o && (r = await Promise.resolve(o())), !r && !this.isProd())
      try {
        r = (await l.get(a)).data;
      } catch (p) {
        throw new Error(
          'envManager - Method "configure" was unable to download the configuration',
          p
        );
      }
    if (r) {
      const p = Object.keys(r), h = Object.entries(this.envConfig).filter(([, g]) => g !== void 0 && g !== "").map(([g]) => g), d = p.filter((g) => !h.includes(g));
      if (d.length > 0)
        throw new Error(
          `envManager - Override has extra keys that do not exist in the production configuration: ${d.join(", ")}. Environment: ${r.name ?? this.envConfig.name}`
        );
      Object.assign(this.envConfig, r);
    }
    this.handleAppConfig(), this.putGtmIdCookie(), this.appendOneTrustScript(), this.appendDynatraceScript(), this.appendMCPBeaconScript(), await this.initSplunkObservability(), this.configured = !0;
  }
  /**
   * Handle AppConfig:
   * Configure getLocale based on i18nService
   */
  handleAppConfig() {
    this.appConfig.i18nService && (this.appConfig.getLocale = this.appConfig.i18nService.getCurrentLocale.bind(
      this.appConfig.i18nService
    ));
  }
  /**
   * Add a cookie with the gtmId for this environment
   */
  putGtmIdCookie() {
    this.envConfig.gtmId && this.envConfig.gtmId !== "skip" && (document.cookie = `gtmId=${this.envConfig.gtmId};SameSite=Lax`);
  }
  appendGlobalScript(e, t = {}) {
    return new Promise((i, a) => {
      const o = document.createElement("script");
      o.src = e, o.onload = () => i(), o.onerror = () => a(new Error(`envManager - Error loading script ${e}`)), o.setAttribute("type", "text/javascript"), Object.entries(t).forEach(([r, p]) => {
        o.setAttribute(r, p);
      }), document.head.appendChild(o);
    });
  }
  /**
   * Add OneTrust
   */
  appendOneTrustScript() {
    this.envConfig.isOneTrustEnabled && this.appendGlobalScript("https://cdn.cookielaw.org/scripttemplates/otSDKStub.js", {
      "data-document-language": "true",
      charset: "UTF-8",
      "data-domain-script": `${this.envConfig.oneTrustDataDomain}${this.isProd() ? "" : "-test"}`
    });
  }
  /**
   * Add Dynatrace Script
   */
  appendDynatraceScript() {
    s.config.dynatraceScriptUrl && this.appendGlobalScript(s.config.dynatraceScriptUrl, { crossorigin: "anonymous" });
  }
  /**
   * Add Beacon MCP Script
   */
  appendMCPBeaconScript() {
    if (s.config.isBeaconMCPScriptEnabled) {
      const e = this.isProd() ? "https://cdn.evgnet.com/beacon/accorsa/accor/scripts/evergage.min.js" : "https://cdn.evgnet.com/beacon/accorsa/accortest/scripts/evergage.min.js";
      this.appendGlobalScript(e);
    }
  }
  /**
   * Add Splunk RUM and Session Recorder
   */
  async initSplunkObservability() {
    try {
      if (s.config.splunkRUM) {
        const e = (await import("../index-CMkvHvN5.js")).default, t = {
          ...s.config.splunkRUM,
          deploymentEnvironment: this.getEnvName().toUpperCase(),
          version: this.appConfig.getAppVersion()
        };
        e.init(t), l.get(window.location.href).then((i) => {
          var o;
          const a = (o = i == null ? void 0 : i.headers) == null ? void 0 : o["x-cdn-forward"];
          a && e.setGlobalAttributes({
            "x-cdn-forward": a
          });
        }).catch((i) => {
          console.error(i);
        }), s.config.splunkSessionRecorder && (await import("../index-uJVuwd3W.js")).default.init(s.config.splunkSessionRecorder);
      }
    } catch (e) {
      console.warn("envManager - Could not load Splunk o11y", e);
    }
  }
}
const f = new C();
class w {
  constructor(e) {
    /**
     *
     * @returns boolean wheter the current env is the production environment
     */
    c(this, "isProd");
    /**
     * A read only EnvConfiguration
     */
    c(this, "config");
    c(this, "appConfig");
    this.isProd = e.isProd.bind(e);
    const t = {
      set() {
        throw new Error("env - Environment is immutable in env. Use envManager.");
      },
      get(i, a) {
        return i[a];
      }
    };
    this.config = new Proxy(e.envConfig, t), this.appConfig = new Proxy(e.appConfig, t);
  }
  /**
   * Compute an absolute url to the instance of all.accor.com of this environment
   * @param path a HTTP path to append to the all.accor.com origin configured for this environment
   * @returns an absolute path to all.accor.com with the path
   */
  urlAllAccorCom(e) {
    return new URL(e, this.config.allAccorComOrigin).toString();
  }
  generateGetter(e) {
    return () => this.config[e];
  }
  getLocale() {
    return f.appConfig.getLocale();
  }
  filterAllAccorComByEnv(e) {
    const i = new URL(window.location.href).hostname;
    return e.replaceAll("all.accor.com", i);
  }
}
const s = new w(f);
export {
  w as Env,
  C as EnvManager,
  v as GetTokenErrorEnum,
  s as env,
  f as envManager
};
//# sourceMappingURL=envManager.js.map
